import PropTypes from 'prop-types';
import { useState } from 'react';

import closeButtonIcon from '../../assets/images/closebuttonact.svg';
import closeButtonIconDis from '../../assets/images/closeButtonDis.svg';
import pdfIcon from '../../assets/images/document-format.svg';
import minusIcon from '../../assets/images/minusActive.svg';
import minusIconAct from '../../assets/images/minusDis.svg';
import plusIcon from '../../assets/images/plusAcitvesvg.svg';
import styles from './styles/styles.module.css';

function FileItem({ id, nameFile, sizeFile, deleteFile, copies, setCopies, isEdit }) {
  const [loading, setLoading] = useState(true);
  const [hover, setHover] = useState(false);
  console.log(isEdit, 'isEdit');
  return (
    <div className={styles.fileItemWrapper}>
      <div className={styles.infoIconFileWrapper}>
        <img src={pdfIcon} alt="Формат документа" />
        <div className={styles.infoItemWrapper}>
          <span>{nameFile}</span>
          <span>{sizeFile} мб</span>
        </div>
      </div>
      <div>
        {loading ? (
          <div className={styles.loaderLine} onAnimationEnd={() => setLoading(false)} />
        ) : (
          <div className={styles.counterWrapper}>
            <div className={styles.countRow}>
              <button
                type="button"
                onClick={() => {
                  setCopies(id, copies <= 1 ? 1 : copies - 1, isEdit);
                }}
                className={`${styles.counterIcon} ${copies <= 1 ? styles.dis : ''}`}
              >
                <img src={copies <= 1 ? minusIconAct : minusIcon} alt="Иконка минуса" />
              </button>
              <div>{copies}</div>
              <button
                type="button"
                onClick={() => {
                  setCopies(id, copies + 1, isEdit);
                }}
                className={styles.counterIcon}
              >
                <img src={plusIcon} alt="Иконка плюса" />
              </button>
            </div>
            <div className={styles.counterText}>Количество копий</div>
          </div>
        )}
        <div className={styles.buttonDeliteWrapper}>
          <button
            className={styles.buttonDelite}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={() => deleteFile(id)}
            type="button"
          >
            <img src={hover ? closeButtonIconDis : closeButtonIcon} alt="Удалить файл" />
          </button>
        </div>
      </div>
    </div>
  );
}

FileItem.propTypes = {
  id: PropTypes.string.isRequired,
  nameFile: PropTypes.string.isRequired,
  sizeFile: PropTypes.string.isRequired,
  deleteFile: PropTypes.func.isRequired,
  copies: PropTypes.number.isRequired,
  setCopies: PropTypes.func.isRequired,
  format: PropTypes.string,
  isEdit: PropTypes.bool,
};

export default FileItem;
